module.exports = __webpack_public_path__ + "img/send-syntax.5314ecc2.png";